export interface IRFMContractorData {
    //identificationCode: string,
    //idTenant: string,
    bpCode: string,
    icaoCode: string,
    iataCode: string,
    companyName: string,
    type: string,
    notes: string,
    currentStatus: string,
    royaltiesDued: any,
    vatNumber: string,
    siren: string,
    siret: string,
    fiscalCode: string,
    legalAddress: string,
    legalStreetNumber: string,
    postalCode: string,
    area: string,
    areaManager: string,
    country:string,
    region: string,
    province: string,
    city: string,
    fax: string,
    pec: string,
    commercialExecutiveName: string,
    naming: string,
    acgIdentificationCode: string,
    serviceType: string[],
    bpCodeOfTheRepresentative: string,
    taxCode: string,
    representativeIdentificationCode: string,
    commercialExecutiveMail: string,
    prefixCommercialExecutiveDeskPhone: {
        code: string,
        description: string,
        label: string
    },
    commercialExecutiveDeskPhone: string,
    prefixCommercialExecutiveCellPhone: {
        code: string,
        description: string,
        label: string
    },
    commercialExecutiveCellPhone: string,
    nameOfTheContactPerson: string,
    emailOfTheContactPerson: string,
    cellPhoneNumberOfTheContactPerson: string,
    prefixCellPhoneNumberOfTheContactPerson: {
        code: string,
        description: string,
        label: string
    },
    iban: string,
    RFMFilterParams: object,
}

export interface IContractorSearchForm {
    icaoCode: string,
    iataCode: string,
    companyName: string,
    type: string,
    currentStatus: string,
    vatNumber: string,
    siren: string,
    fiscalCode: string,
    city: string,
    region: string,
    province: string,
    bpCode:string,
    country: string,
    tenants: null | string[],
    dealers: null | string[]
}

export interface IContractorSearchReqParams {
    icaoCode?: string,
    iataCode?: string,
    companyName?: string,
    type?: string,
    currentStatus?: string,
    vatNumber?: string,
    siren?: string,
    fiscalCode?: string,
    city?: string,
    region?: string,
    province?: string,
    bpCode?:string,
    country?: string,
    paramRequest?: {
        totCount?: number,
        pagination?: number,
        startIndex?: number,
        endIndex?: number,
        sortBy?: {
            field?: string,
            order?: string
        }
    }
}

// export const listRFMContractorType = [
//     {
//         code: 'APT',
//         label: 'APT'
//     },
//     {
//         code: 'RA',
//         label: 'RA'
//     },
//     {
//         code: 'CA',
//         label: 'CA'
//     },
//     {
//         code: 'Other',
//         label: 'Other'
//     }
// ];

export const listRFMContractorType = [
    'APT',
    'RS',
    'CA',
    'Harbour',
    'Mall',
    'Retailer',
    'Reserve',
    'Other'
];

export interface IRFMContractorDataForm {
    contractorData: IRFMContractorData
}

// Form
export interface FormValuesType extends Record<string, any> {
    contractorData: IRFMContractorData,
    idEntity: string | null
}

export interface HttpResponseType<T> {
    data: T,
    loading: boolean,
    error: string
}

export interface IRoyaltiesContractor{
    id:number,
    royaltiesEmail: string,
    royaltiesRate: string,
    contractorType: string,
    rateable: string,
    contractorIdentificationCode: string,
    contractorName: string,
    voices: Array<IRule>,
    splitOffs: Array<IRule>
}

export interface IRule{
    type: string | null
}

export interface IRoyalties{
    id: number,
    rateable: string,
    voices: Array<string>,
    splitOffs: Array<string>
}

export interface IRoyaltiesSearchFilters {
    tenants: any[] | null;
    dealers: any[] | null;
}
